module.exports = "<!--created by AHMED HAYEL-->\r\n\r\n<div id=\"showtime\">\r\n    <b class=\"error\">404 Page not Available or you are not authenticated</b>\r\n    <a (click)=\"back()\" class=\"hyber\">click here to go back</a>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/error/error.component.html
// module id = 386
// module chunks = 1